import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function ProductShowcase() {
  const tomos = [{
    emoji: '📗',
    num: '1',
    title: 'El Rey del Freezer',
    desc: 'Batch cooking, milanesas, tartas y todo lo que se congela y te salva la semana'
  }, {
    emoji: '📘',
    num: '2',
    title: 'Express de Invierno',
    desc: 'Guisos, sopas y pastas calientes en 20 minutos'
  }, {
    emoji: '📒',
    num: '3',
    title: 'Ensaladas que Llenan',
    desc: 'Bowls y ensaladas completas con proteína que cierran el almuerzo de verdad'
  }, {
    emoji: '📔',
    num: '4',
    title: 'Cero Hornalla',
    desc: 'Sandwiches, wraps y bowls fríos. El tomo del verano y los días imposibles'
  }, {
    emoji: '📕',
    num: '5',
    title: 'Legumbres sin Miedo',
    desc: '18 recetas con lentejas, garbanzos y porotos que cualquiera puede hacer'
  }, {
    emoji: '📙',
    num: '6',
    title: 'El Salvador del Domingo',
    desc: 'Batch cooking completo. Cocinás una vez y comés bien 5 días'
  }];
  const includes = ['Menú semanal listo para usar', 'Recetas paso a paso con tiempos reales', 'Lista de compras por tomo', 'Sistema de freezer y almacenaje', 'Tabla de reemplazos de ingredientes', 'Checklist de implementación semanal'];
  return <section className="py-20 px-4" data-id="element-274">
      <div className="max-w-5xl mx-auto" data-id="element-275">
        <div className="text-center mb-16" data-id="element-276">
          <div className="inline-block px-4 py-1.5 rounded-full bg-brand-gold/10 text-brand-gold font-medium mb-4" data-id="element-277">
            📚 PACK ¿QUÉ COMEMOS HOY?™
          </div>
          <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-278">
            6 Tomos + 6 Bonos — 480 páginas
          </h2>
          <p className="text-xl text-gray-400" data-id="element-279">
            Todo resuelto. Para toda la semana.
          </p>
        </div>

        <h3 className="text-2xl font-bold mb-8 flex items-center gap-2" data-id="element-280">
          <span className="text-brand-gold" data-id="element-281">📗</span> LOS 6 TOMOS
        </h3>

        <div className="grid md:grid-cols-2 gap-4 mb-16" data-id="element-282">
          {tomos.map((tomo, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-brand-card p-6 rounded-2xl border border-white/5 flex gap-4" data-id="element-283">
              <div className="text-4xl shrink-0" data-id="element-284">{tomo.emoji}</div>
              <div data-id="element-285">
                <div className="text-brand-gold text-sm font-bold mb-1" data-id="element-286">
                  Tomo {tomo.num}
                </div>
                <h4 className="text-xl font-bold mb-2" data-id="element-287">{tomo.title}</h4>
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-288">
                  {tomo.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <div className="bg-brand-darker p-8 rounded-3xl border border-brand-gold/20" data-id="element-289">
          <h4 className="text-xl font-bold mb-6 text-center" data-id="element-290">
            Cada tomo incluye:
          </h4>
          <div className="grid md:grid-cols-2 gap-4" data-id="element-291">
            {includes.map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-292">
                <CheckCircle2 className="w-5 h-5 text-brand-gold shrink-0" data-id="element-293" />
                <span className="text-gray-300" data-id="element-294">{item}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}